import { CopyIcon, Eye, EyeOff } from "lucide-react";
import { useContext, useState } from "react";

import {
  captureProductEvent,
  productAnalyticsEvents,
} from "../analytics/events";
import { Button } from "./ui/button";
import { Toggle } from "./ui/toggle";
import { UserContext } from "@/contexts/UserContext";
import sendStandardEvent from "@/hooks/use-firebase-event";
import { copyToClipboard } from "@/lib/clipboard";
import { pushSuccess } from "@/slices/notifications";
import { useDispatch } from "@/store";

type CodeSnippetProps = {
  code: string;
  copyInfo: string;
  showViewToggle?: boolean;
};

export default function CodeSnippet({
  code,
  copyInfo,
  showViewToggle,
}: CodeSnippetProps) {
  const dispatch = useDispatch();
  const { user } = useContext(UserContext);

  const [showSnippet, setShowSnippet] = useState(false);

  return (
    <span className="relative">
      <div className="absolute top-2 right-2 flex gap-2">
        {showViewToggle && (
          <Toggle
            asChild
            pressed={showSnippet}
            onPressedChange={setShowSnippet}
          >
            <Button variant="secondary" className="border">
              {!showSnippet ? <Eye /> : <EyeOff />}
            </Button>
          </Toggle>
        )}
        <Button
          variant="secondary"
          onClick={async () => {
            await copyToClipboard(code);
            if (copyInfo === "clusterToken") {
              captureProductEvent(
                productAnalyticsEvents.activationClusterTokenCopied,
              );
            }
            sendStandardEvent(`copied_${copyInfo}`, "copying", user);
            dispatch(pushSuccess("Copied"));
          }}
          className="border"
        >
          <CopyIcon />
        </Button>
      </div>
      <pre className="overflow-x-auto px-4 py-6 text-sm text-muted-foreground bg-muted rounded-lg border">
        <code>{!showViewToggle || showSnippet ? code : "*****"}</code>
      </pre>
    </span>
  );
}
